import React from "react";
import styled from "styled-components";
import { RTEWrapper } from "BaseComponents/Wrappers/RTEWrapper";
export const CrisisBanner = ({ ShowPublicAnnouncement, AnnouncementText }) => {
	return (
		ShowPublicAnnouncement && (
			<BannerWrapper>
				<BannerContent>
					<Icon className="icon-attention-1"></Icon>
					<div>
						{/* <H2>{AnnouncementHeading}</H2> */}
						{AnnouncementText && (
							<RTEWrapper
								bold
								margin="0 0 0 12px"
								pMargin="0"
								dangerouslySetInnerHTML={{
									__html: AnnouncementText,
								}}
							></RTEWrapper>
						)}
					</div>
				</BannerContent>
			</BannerWrapper>
		)
	);
};
export const BannerContent = styled.div`
	display: flex;
	align-items: center;
	flex-direction: row;
`;
export const Icon = styled.i`
	font-size: 24px;
	color: ${({ theme }) => theme.colors.iconColor};
`;
export const BannerWrapper = styled.div`
	display: flex;
	background: #fdead4;
	padding: 8px 16px;
	z-index: 999;
	width: 100%;
	margin-bottom: 25px;
`;
